export type EmajinSectionBenefitItem = {
  id: string
  title: string
  caption: string
}

export const EMAJIN_SECTION_BENEFIT_ITEMS: EmajinSectionBenefitItem[] = [
  {
    id: 'EmajinSectionBenefitItem-001',
    title: 'Access',
    caption:
      'to play at some of the best golf courses and hidden gems across Australia',
  },
  {
    id: 'EmajinSectionBenefitItem-002',
    title: 'Learn',
    caption:
      'from senior executives as keynote speakers on relevant industry topics',
  },
  {
    id: 'EmajinSectionBenefitItem-003',
    title: 'Grow',
    caption:
      'your business network of senior business owners and c-suite executives Our events are exciting, innovative and fun!',
  },
]
